<div class="image-overlay">
  <img [src]="imgSrc" [alt]="imgAlt" loading="lazy" />
  <div class="gradient" [ngClass]="gradient"></div>
  <div
    class="overlay-content-wrapper"
    [ngClass]="contentPosition"
    data-test="overlay-content-wrapper"
  >
    <ng-content></ng-content>
  </div>
</div>
